import React from "react";
import socketIOClient from "socket.io-client";
import { isSafari } from "./tools";

const NEW_ORDER_EVENT = "shop new order"
const SOCKET_SERVER_URL = process.env.REACT_APP_WEBSOCKET_SERVER

const useNotif = (roomId) => {
    const [notif, setNotif] = React.useState([])
    const socketRef = React.useRef();

    React.useEffect(() => {
        socketRef.current = socketIOClient(SOCKET_SERVER_URL, {
            query: { roomId },
            transports: ["websocket"],
            forceNew: true,
        })

        socketRef.current.on('connect', () => {
            console.log("CONNECTED")
        })

        socketRef.current.on('error', (error) => {
            console.log("ERROR: ", error)
        })
        socketRef.current.on('connect_error', (error) => {
            console.log("CONNECTED ERROR: ", error)
        })

        socketRef.current.on(NEW_ORDER_EVENT, (data) => {
            const newNotif = {
                title: "New Order",
                ...data
            }
            setNotif((notif) => [...notif, newNotif])
        });

        return () => {
            socketRef.current.disconnect();
        }

    },[roomId]);

    const checkNotifPermission = () => {
        return new Promise((resolve, reject) => {
            if (!("Notification" in window)) {
                alert("This browser does not support desktop notification");
                reject(false)
            } else if (Notification.permission !== "denied") {
                Notification.requestPermission().then(function (permission) {
                    if (permission === "granted") {
                        new Notification("Terimakasih !");
                        resolve(true)
                    }
                })
            } else if (Notification.permission === "granted") {
                return resolve(true)
            }
        })
    }

    const displayNotification = (title, options) => {
        if (!isSafari) {
            if (Notification.permission === "granted") {
                navigator.serviceWorker.ready.then(function (reg) {
                    reg.showNotification(title, options);
                })  
            } else {
                checkNotifPermission()
            }
        }
    }



    return {notif, displayNotification}
}

export default useNotif;